import { FaSearch, FaPencilRuler, FaCode, FaCheckCircle, FaRocket, FaLifeRing } from "react-icons/fa";
import AnimatedHeading from "../shared/AnimatedHeading";

const steps = [
  {
    icon: <FaSearch className="text-blue-500 w-8 h-8" />,
    title: "Discovery & Planning",
    description: "We begin by understanding your business objectives, user needs, and technical requirements to create a comprehensive roadmap.",
  },
  {
    icon: <FaPencilRuler className="text-purple-500 w-8 h-8" />,
    title: "Design & Prototyping",
    description: "Our team crafts user-centric designs and interactive prototypes that validate concepts before development begins.",
  },
  {
    icon: <FaCode className="text-green-500 w-8 h-8" />,
    title: "Development",
    description: "Using agile methodologies, we build your solution with regular iterations and continuous feedback to ensure alignment with your vision.",
  },
  {
    icon: <FaCheckCircle className="text-yellow-500 w-8 h-8" />,
    title: "Testing & Quality Assurance",
    description: "Rigorous testing across devices, browsers, and scenarios ensures your solution performs flawlessly for all users.",
  },
  {
    icon: <FaRocket className="text-pink-500 w-8 h-8" />,
    title: "Deployment & Launch",
    description: "We manage the transition to production with minimal disruption, ensuring a smooth launch.",
  },
  {
    icon: <FaLifeRing className="text-indigo-500 w-8 h-8" />,
    title: "Ongoing Support",
    description: "Our relationship continues after launch with maintenance, optimization, and scaling to support your evolving needs.",
  },
];

const ApproachSection = () => (
  <section className="py-16 bg-white">
    <div className="container mx-auto px-6 max-w-6xl">
      {/* <h2 className="text-3xl sm:text-4xl font-extrabold mb-4 text-center text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">
        Our Approach
      </h2>
      <h3 className="text-xl font-semibold mb-10 text-center text-gray-700">
        How We Work
      </h3> */}
      <h5 className="text-md font-bold text-center mb-2 text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500">
          Our Approach
        </h5>
        <AnimatedHeading text="How We Work" />
      <div className="grid gap-8 md:grid-cols-3">
        {steps.map((step, idx) => (
          <div key={idx} className="bg-gray-50 rounded-xl shadow p-6 flex flex-col items-center text-center hover:shadow-lg transition">
            <div className="bg-white border-4 border-blue-100 rounded-full p-4 shadow mb-2 z-10">
                {step.icon}
              </div>
            <h4 className="font-bold text-lg mb-2">{step.title}</h4>
            <p className="text-gray-600">{step.description}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ApproachSection;